


















import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AssetData, AssetRef } from '@/types';
import { ProjectData } from '@/store/project/types';
import { AssetActions } from '../../store/asset/actions';
import {
  ExportOptions, ExportType, MediaType, OptionsObject,
} from './types';
import ExportDataPopout from './ExportDataPopout.vue';

const assetModule = namespace('asset');
const projectModule = namespace('project');

@Component({
  components: {
    ExportDataPopout,
  },
})
export default class AssetTableExportDataPopout extends Vue {
  @Prop({ default: () => [] }) readonly assets: AssetData[];

  @Prop() readonly tableData: AssetData[];

  @assetModule.State('exportState') exportState: string;

  @assetModule.Action(AssetActions.EXPORT_ASSETS) exportAssets;

  @projectModule.State('data') project: ProjectData | undefined;

  get exportOptionsObject(): ExportOptions {
    return {
      exportTypeCheckboxes: {
        visible: true,
        options: [
          { name: ExportType.PDF, disabled: false, value: false },
          { name: ExportType.DB, disabled: this.selectedAssets, value: false },
          { name: ExportType.CSV, disabled: false, value: false },
        ],
      },
      mediaTypeCheckboxes: {
        visible: true,
        options: [
          { name: MediaType.VIDEOS, disabled: this.selectedAssets, value: false },
          { name: MediaType.COUNTER_IPD, disabled: this.selectedAssets, value: false },
          { name: MediaType.PHOTOS, disabled: this.selectedAssets, value: false },
        ],
      },
      validationOptionsSection: {
        visible: true,
      },
    };
  }

  get assetGuids(): string[] {
    let assetData = [];
    if (this.assets.length > 0) {
      assetData = this.assets;
    } else if (this.tableData.length > 0) {
      assetData = this.tableData;
    }
    return [
      ...new Set(assetData.map((item) => item.guid).filter((item) => !!item)),
    ];
  }

  get selectedAssets(): boolean {
    return this.assets.length === 0;
  }
}
